module.exports = __webpack_public_path__ + "static/media/L-7.ee19df79.svg";